// extracted by mini-css-extract-plugin
export default {"title":"CredentialsSection_title__Jnlm9","credentialsCardContainer":"CredentialsSection_credentialsCardContainer__igpSX"};